;(function () {
    "use strict";

    $(document).ready(function() {

        if (navigator.appVersion.match(/windows nt 5\.\d/i)) {
            $('html').addClass('win-xp');
        }

        if (Boolean(navigator.userAgent.match('Chrome/37'))) {
            $('.rouble.rouble_semibold')
            .css({
                'font-weight': '400',
                'font-size':   '0.85em'
            });
        }
    });
})();